const KEY = "sabrea_attribution_v1";
const UTM = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

// Captured once per session on first landing so the /join role step never destroys attribution.
export const captureAttribution = () => {
  let stored = {};
  try {
    stored = JSON.parse(sessionStorage.getItem(KEY)) || {};
  } catch {
    stored = {};
  }
  const params = new URLSearchParams(window.location.search);
  const next = { ...stored };
  UTM.forEach((k) => {
    const v = params.get(k);
    if (v) next[k] = v;
  });
  if (!next.landing_page) next.landing_page = window.location.href.slice(0, 400);
  if (!next.referring_url && document.referrer) next.referring_url = document.referrer.slice(0, 400);
  try {
    sessionStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* storage unavailable — attribution is best-effort */
  }
  return next;
};

export const getAttribution = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || captureAttribution();
  } catch {
    return {};
  }
};
